/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react';
import './TeachersSection.css';

const TeachersSection = () => {
    const [expandedTeacher, setExpandedTeacher] = useState(null);
    const [showAllTeachers, setShowAllTeachers] = useState(false);

    const teachers = [
        {
            id: 1,
            name: "Mr. Shahrukh Khan",
            designation: "Academic Head of Department (Mathematics)",
            image: "/assets/teachers/shahrukhsir.jpg",
            expertise: "Mathematics, Competitive Exam Preparation, Career Guidance",
            experience: "7+ years of teaching excellence",
            details: "B.Tech in ECE from Krishna Engineering College, pursuing M.Sc. in Mathematics from Abeda Inamdar Senior College. Achieved AIR 256 in Teaching Professional Olympiad (CENTA). Former SME at Toppr Technology Limited. Multiple GATE qualifications (2016-20). Specializes in mathematical aptitude and competitive exam preparation. Currently serving as Academic HOD at Kutty's Academy, with expertise in teacher training and career guidance programs.",
            linkedin: "https://linkedin.com"
        },
        {
            id: 2,
            name: "Mr. Hrishikesh Sanjay Gaikwad",
            designation: "Mathematics & Chemistry Faculty",
            image: "/assets/teachers/hrishikeshsir.jpg",
            expertise: "Mathematics, Chemistry, Competitive Exam Training",
            experience: "5+ years of teaching experience",
            details: "B.Sc in Mathematics with 95% from SPPU. Expert in MHT-CET, NEET & JEE Mains preparation. Currently working with Education Hub Coaching Classes and TCS. Specializes in exam paper setting and competitive exam training.",
            linkedin: "https://linkedin.com"
        },
        {
            id: 3,
            name: "Mr. Udayraj Singh",
            designation: "Mathematics Coach & HOD Competitive Exams",
            image: "/assets/teachers/udaysir.jpg",
            expertise: "Mathematics, Competitive Exam Preparation, Educational Technology",
            experience: "8+ years of teaching experience",
            details: "B.E. in Computer Science and B.Ed. qualified. Pursuing B.Sc. in Data Science from IIT Madras. Specializes in JEE, NDA, CET, SSC CGL, AFCAT, and CDS preparation. Experienced teacher trainer and counselor with excellent interpersonal skills. Associated with prestigious institutions including Scholar Batch Inamdar College, IITian's Prashikshan Kendra, and leading ADCI's competitive exam department.",
            linkedin: "https://linkedin.com"
        },
        {
            id: 4,
            name: "Mr. Afroj Nadaf",
            designation: "Mathematics Educator",
            image: "/assets/teachers/afrozsir.jpg",
            expertise: "Mathematics, Academic Leadership, Online Tutoring",
            experience: "4+ years of teaching experience",
            details: "M.Sc. in Mathematics from Vivekanand College Kolhapur and B.Ed. in Mathematics and Science. Former Head of Academic Department (Maths) at Millat Scholars Academy. Specializes in classroom management, innovative teaching methodologies, and fostering dynamic learning environments. Currently teaching at Kutty's Academy with previous experience at Anees Classes.",
            linkedin: "https://linkedin.com"
        },
        {
            id: 5,
            name: "Mr. Aman Kumar",
            designation: "Senior Mathematics Faculty",
            image: "/assets/teachers/amansir.jpg",
            expertise: "Mathematics, IIT-JEE, Defence Exams, Academic Content Development",
            experience: "6+ years of combined teaching and content development experience",
            details: "M.E. in Design Engineering from SPPU. Expert in innovative problem-solving and curriculum design. Former SME at Testbook and Toppr.com. Specializes in competitive exam preparation and mathematics content development. Currently leading mathematics instruction at ADCI with focus on conceptual clarity and problem-solving abilities.",
            linkedin: "https://linkedin.com"
        },
        {
            id: 6,
            name: "Mr. Ilyas Bashir Rather",
            designation: "Senior Mathematics Faculty",
            image: "/assets/teachers/ilyassir.jpg",
            expertise: "Mathematics, JEE, NDA Preparation",
            experience: "Mathematics Faculty at ADCI and Rkvity Classes",
            details: "B.Tech in Chemical Engineering from NIT Srinagar. 3+ years of experience,JEE advanced qualified,69th Rank in JKCET, 7th Rank in AMUEEE, Passionate mathematician dedicated to cultivating a love for numbers. Specializes in innovative teaching methods for JEE and NDA preparation. Expertise in fostering critical thinking and problem-solving abilities.",
            linkedin: "https://linkedin.com"
        }
    ];

    const handleExpand = (teacherId) => {
        setExpandedTeacher(prevId => prevId === teacherId ? null : teacherId);
    };

    return (
        <div className={`teachers-section ${showAllTeachers ? 'show-all' : ''}`}>
            <div className="section-content">
                <div className="teachers-header">
                    <h2 className="teachers-title">
                        <span className="glitch-wrapper">
                            <span className="glitch" data-text="MENTORS OF EXCELLENCE">MENTORS OF EXCELLENCE</span>
                        </span>
                    </h2>
                    <p className="teachers-subheading" data-text="Shaping Tomorrow's Leaders Today">Shaping Tomorrow's Leaders Today</p>
                </div>
                <div className="bubble-1"></div>
                <div className="bubble-2"></div>
                <div className="bubble-3"></div>
                <div className="bubble-4"></div>
                <div className="bubble-5"></div>
                <div className="bubble-6"></div>
                <div className="bubble-7"></div>
                <div className="bubble-8"></div>
                <div className="bubble-9"></div>
                <div className="teachers-container">
                    <div className="teachers-grid">
                        {/* Display teachers */}
                        {teachers.map((teacher) => (
                            <div
                                key={teacher.id}
                                className={`teacher-card ${expandedTeacher === teacher.id ? 'expanded' : ''}`}
                                onClick={() => handleExpand(teacher.id)}
                            >
                                <div className="teacher-card-inner">
                                    <div className="teacher-image-container">
                                        <img src={teacher.image} alt={teacher.name} className="teacher-image" />
                                    </div>
                                    <h3 className="teacher-name">{teacher.name}</h3>
                                    <p className="teacher-designation">{teacher.designation}</p>
                                    <div className="teacher-details">
                                        <div className="detail-item">
                                            <strong>Expertise</strong>
                                            <p>{teacher.expertise}</p>
                                        </div>
                                        <div className="detail-item">
                                            <strong>Experience</strong>
                                            <p>{teacher.experience}</p>
                                        </div>
                                        <div className="detail-item">
                                            <strong>Background</strong>
                                            <p>{teacher.details}</p>
                                        </div>
                                    </div>
                                    <button className="expand-button"></button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="view-more-container">
                        {!showAllTeachers && (
                            <button 
                                className="view-more-button"
                                onClick={() => setShowAllTeachers(true)}
                            >
                                View More Teachers
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeachersSection;
